import Index from '../views/clinics/Index';
import AppointmentIndex from '../views/appointment/Index';
import RegistryIndex from '../views/registry/Index';
import Public from '../views/clinics/pages/Public';
import PersonalArea from '../views/clinics/pages/personal-area/Index';
import Clinic from '../views/clinics/pages/personal-area/pages/Clinic';
import Main from '../views/clinics/pages/personal-area/pages/Main';
import Personal from '../views/clinics/pages/personal-area/pages/Personal';
import Modules from '../views/clinics/pages/personal-area/pages/Modules';
import Settings from '../views/clinics/pages/personal-area/pages/Settings';
import Help from '../views/clinics/pages/personal-area/pages/Help';
import Staff from '../views/clinics/pages/personal-area/pages/Staff';
import ReceptionIndex from '../views/reception/Index';
import Reception from '../views/reception/pages/Reception';
import CurrentPatient from '../views/reception/pages/CurrentPatient';

import appointmentRoutes from './appointment';
import registryRoutes from './registry';

import Appointment from '@app/appointment';
import TestPage from '@app/views/TestPage';
import SimpleLanding from '@app/views/simple-landing';

export default {
  path: '/clinics',
  component: Index,
  meta: {
    validate: ['two_factor', 'lock_screen']
  },
  children: [
    // {
    //   path: ':clinicName',
    //   name: 'clinic.public',
    //   component: Public
    // },
    {
      path: ':clinicName/test',
      name: 'clinic.test',
      component: Appointment
    },
    {
      path: ':clinicName/personal-area',
      meta: {
        resources: [
          {
            type: 'organization',
            roles: ['orgadmin', 'doctor', 'employee', 'patient']
          }
        ],
        validate: ['auth', 'two_factor', 'lock_screen']
      },
      component: PersonalArea,
      children: [
        {
          path: '/',
          name: 'personal-area.main',
          component: Main
        },
        {
          path: 'clinic',
          name: 'personal-area.clinic',
          meta: {
            resources: [
              {
                type: 'organization',
                roles: ['orgadmin']
              }
            ]
          },
          component: Clinic
        },
        {
          path: 'registry',
          component: RegistryIndex,
          meta: {
            resources: [
              {
                type: 'organization',
                roles: ['orgadmin', 'doctor']
              }
            ]
          },
          children: registryRoutes
        },
        {
          path: 'appointment',
          component: AppointmentIndex,
          meta: {
            resources: [
              {
                type: 'organization',
                roles: ['patient']
              }
            ]
          },
          children: appointmentRoutes
        },
        {
          path: 'personal',
          name: 'personal-area.personal',
          component: Personal
        },
        {
          path: 'modules',
          name: 'personal-area.modules',
          meta: {
            resources: [
              {
                type: 'organization',
                roles: ['orgadmin']
              }
            ]
          },
          component: Modules
        },
        {
          path: 'settings',
          name: 'personal-area.settings',
          component: Settings
        },
        {
          path: 'help',
          name: 'personal-area.help',
          component: Help
        },
        {
          path: 'staff',
          name: 'personal-area.staff',
          component: Staff
        },
        {
          path: '',
         // name: 'reception',
          component: ReceptionIndex,
          children: [
            {
              path: 'reception',
              name: 'reception',
              component: Reception
            },
            {
              path: 'reception/currentpatient',
              name: 'currentpatient',
              component: CurrentPatient
            }
          ]
        }
      ]
    }
  ]
};
